// extracted by mini-css-extract-plugin
module.exports = {"base":"Page_base__23QWc","body":"Page_body__3VWkm","bodyNoPadding":"Page_bodyNoPadding__GsxOR","stickyHeader":"Page_stickyHeader__1Ab-z"};